import api, { unwrapList } from './api';
const leaveService = {
  getAll:  (p)  => api.get('/leaves/', { params: p }).then(r => unwrapList(r.data)),
  apply:   (d)  => api.post('/leaves/', d).then(r => r.data),
  cancel:  (id) => api.patch(`/leaves/${id}/cancel/`).then(r => r.data),
};
export default leaveService;